"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnualQuoteSummaryPanelWidget = void 0;
var React = require("react");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var commonFunctions_1 = require("../../../commonFunctions");
var core_1 = require("@athena-portal/core");
var reactstrap_1 = require("reactstrap");
var services_1 = require("@falcon/services");
var drivingLicenceHelper_1 = require("../../../helpers/drivingLicenceHelper");
var SummaryPhoneNumberInput_1 = require("../../../components/annual/SummaryPhoneNumberInput");
var AnnualMotorGlassAndRepairExcessWordingGenerator_1 = require("../../../helpers/annual/motor/AnnualMotorGlassAndRepairExcessWordingGenerator");
var AnnualQuoteSummaryPanelWidget = exports.AnnualQuoteSummaryPanelWidget = /** @class */ (function (_super) {
    __extends(AnnualQuoteSummaryPanelWidget, _super);
    function AnnualQuoteSummaryPanelWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.getVehiclesAdditionalDrivers = function (interaction) {
            var vehicleDrivers = new Set();
            interaction.vehicles.forEach(function (vehicle) {
                vehicle.driverIds.forEach(function (driverId) {
                    var driver = interaction.additionalDrivers.find(function (driver) { return driverId === driver.personId && interaction.policyHolder.personId !== driver.personId; });
                    if (driver) {
                        vehicleDrivers.add(driver);
                    }
                });
            });
            return Array.from(vehicleDrivers);
        };
        _this.handleRegistrationNumberChange = function (event) {
            event.preventDefault();
            var editableVehicleVrn = event.target.value.trim().toUpperCase();
            _this.setState({ editableVehicleVrn: editableVehicleVrn });
            var vrnValidRegex = /(^[A-Za-z]{2}[0-9]{2} [A-Za-z]{3}$)|(^[A-Za-z][0-9]{1,3} [A-Za-z]{3}$)|(^[A-Za-z]{3} [0-9]{1,3}[A-Za-z]$)|(^[0-9]{1,4} [A-Za-z]{1,2}$)|(^[0-9]{1,3} [A-Za-z]{1,4}$)|(^[A-Za-z]{1,2} [0-9]{1,4}$)|(^[A-Za-z]{1,3} [0-9]{1,4}$)|(^[A-Za-z]{2}[0-9]{2}[A-Za-z]{3}$)|(^[A-Za-z][0-9]{1,3}[A-Za-z]{3}$)|(^[A-Za-z]{3}[0-9]{1,3}[A-Za-z]$)|(^[0-9]{1,4}[A-Za-z]{1,2}$)|(^[0-9]{1,3}[A-Za-z]{1,4}$)|(^[A-Za-z]{1,2}[0-9]{1,4}$)|(^[A-Za-z]{1,3}[0-9]{1,4}$)|(^[A-Za-z]{4}[0-9]{3}$)|(^[A-Za-z]{4} [0-9]{3}$)|(^[A-Za-z]{2}[0,9]{2}[A-Za-z]{2})|(^[0-9]{2}[A-Za-z]{2}[0-9]{2})|(^[0-9]{3}[A-Za-z]{1}[0-9]{3})/;
            var isValid = vrnValidRegex.test(event.target.value);
            _this.setState({
                vrnValidated: isValid
            });
            var isAllowed = true;
            if (isValid) {
                var vrnAllowedRegex = /(^Q[a-zA-Z0-9]{6,}$)|(^[0-9]{3,}[X|D][0-9]{3,}$)/;
                isAllowed = !vrnAllowedRegex.test(event.target.value);
            }
            _this.setState({
                vrnAllowed: isAllowed
            });
        };
        _this.handleNameChange = function (event) {
            var existingDriver = _this.state.editFullNameDriver;
            if (event.target.id === "firstNameChange") {
                existingDriver.firstName = event.target.value;
            }
            else {
                existingDriver.lastName = event.target.value;
            }
            _this.setState({ editFullNameDriver: existingDriver });
            event.preventDefault();
        };
        _this.saveRegistrationNumberChanges = function (event) {
            event.preventDefault();
            var vrn = _this.state.editableVehicleVrn;
            _this.props.onStateChange("vehicles[" + _this.state.vrnEditVehicleIndex + "].registrationNumber", vrn);
            _this.toggle();
            _this.executeEvent("change");
        };
        _this.saveFullNameChanges = function (event, driverType, driverIndex) {
            event.preventDefault();
            var editFullNameDriver = _this.state.editFullNameDriver;
            if (driverType === "additionalDriver") {
                _this.props.onStateChange("additionalDriver[".concat(driverIndex, "]"), editFullNameDriver);
            }
            else {
                _this.props.onStateChange(driverType, editFullNameDriver);
            }
            if (_this.allDriverNamesAreValid()) {
                _this.props.onStateChange("uistate.allDriverNamesValid", true);
            }
            _this.toggleEditFullNamePopup();
            _this.executeEvent("change");
        };
        _this.state = {
            lookup: [],
            vrnEditPopupOpened: false,
            vrnEditVehicleIndex: null,
            editableVehicleVrn: "",
            vrnValidated: true,
            vrnAllowed: true,
            editFullNamePopupOpened: false,
            editFullNameDriver: null,
            editFullNameDriverType: "",
            editFullNameDriverIndex: -1,
            vrn: props.interaction.vehicles[0].registrationNumber,
            isVRNValid: _this.validateVRN(props.interaction.vehicles[0].registrationNumber),
        };
        _this.vehicles = props.interaction.vehicles;
        _this.navigateToEditCar = _this.navigateToEditCar.bind(_this);
        _this.navigateToEditPolicyHolder = _this.navigateToEditPolicyHolder.bind(_this);
        _this.navigateToEditAdditionalDriver = _this.navigateToEditAdditionalDriver.bind(_this);
        _this.openEditRegNumberPopup = _this.openEditRegNumberPopup.bind(_this);
        _this.toggle = _this.toggle.bind(_this);
        _this.toggleEditFullNamePopup = _this.toggleEditFullNamePopup.bind(_this);
        _this.handleVRNInput = _this.handleVRNInput.bind(_this);
        _this.validateVRN = _this.validateVRN.bind(_this);
        return _this;
    }
    AnnualQuoteSummaryPanelWidget.prototype.componentDidMount = function () {
        this.fetchLookupValues("vehicleTransmission");
        this.fetchLookupValues("vehicleFuelType");
        this.fetchLookupValues("claimType");
        this.fetchLookupValues("mileage");
        this.fetchLookupValues("carUsage");
        this.fetchLookupValues("ncdEarnType");
    };
    AnnualQuoteSummaryPanelWidget.prototype.render = function () {
        var interaction = this.props.engine.getInteraction();
        return (React.createElement("div", null,
            React.createElement("div", { className: "quote-summary-panel" },
                this.renderCoverDetailsDirect(interaction),
                React.createElement("div", { className: "summary-section car-details" },
                    React.createElement("div", { className: "summary-heading" }, interaction.vehicles && interaction.vehicles.length > 1 ? "Cars details" : "Car details"),
                    this.renderCarsDetails(interaction)),
                React.createElement("div", { className: "summary-section driver-details" },
                    React.createElement("div", { className: "summary-heading" }, interaction.additionalDrivers && interaction.additionalDrivers.length > 0 ? "Drivers details" : "Driver details"),
                    this.renderDriversDetails(interaction))),
            this.state.vrnEditPopupOpened && this.renderVrnPopup(interaction),
            this.state.editFullNamePopupOpened && this.renderFullNameEditPopup()));
    };
    AnnualQuoteSummaryPanelWidget.prototype.getSelectedTierIconName = function () {
        var tierName = "";
        switch (this.props.interaction.coverTier) {
            case services_1.MotorCoverTier.ALLIANZ_ESSENTIALS:
                tierName = "allianz-essentials-tier";
                break;
            case services_1.MotorCoverTier.ALLIANZ_SILVER:
                tierName = "allianz-silver-tier";
                break;
            case services_1.MotorCoverTier.ALLIANZ:
                tierName = "allianz-tier";
        }
        return tierName;
    };
    AnnualQuoteSummaryPanelWidget.prototype.renderCoverDetailsDirect = function (interaction) {
        var _a, _b, _c, _d;
        var premiumType = interaction.factors.premiumType;
        return (React.createElement("div", { className: "cover-details d-flex" },
            React.createElement("div", { className: "cover-details-header d-flex" },
                React.createElement("img", { className: "tier-icon", src: "/".concat(services_1.resourcesHelper.THEME, "/img/").concat(this.getSelectedTierIconName(), ".svg"), alt: "Tier logo" }),
                React.createElement("div", { className: "cover-details-heading d-flex" },
                    React.createElement("div", { className: "summary-heading" }, (0, commonFunctions_1.getCoverTierWording)(this.props.interaction.coverTier))),
                this.getPriceDetails(interaction)),
            React.createElement("div", null,
                this.getDetail("Cover start date:", (0, commonFunctions_1.renderCoverStartDate)(interaction.headerInfo.startDate)),
                this.getDetail("Cover expiry date:", (0, commonFunctions_1.convertDate)(interaction.headerInfo.endDate, "DD MMM YYYY, HH:mm")),
                this.getDetail("Cover type:", "Comprehensive"),
                this.getDetail("Cover level:", (0, commonFunctions_1.getCoverTierWording)(this.props.interaction.coverTier)),
                services_1.InteractionHelper.isPolicyQuotedBeforeFamilyCoverRemoval(interaction) &&
                    this.getDetail("Family Package:", ((_a = interaction.optionalExtras) === null || _a === void 0 ? void 0 : _a.familyPackage) ? "Included" : "Not included"),
                this.getDetail("Breakdown cover:", this.breakdownCoverWording(interaction.optionalExtras)),
                this.getDetail("Protected no claim discount:", ((_c = (_b = interaction.policyHolder) === null || _b === void 0 ? void 0 : _b.ncd) === null || _c === void 0 ? void 0 : _c.doNotDisclose) ? "Included" : "Not included"),
                this.getDetail("Motor legal expenses:", interaction.coverTier !== services_1.ALLIANZ
                    ? (((_d = interaction.optionalExtras) === null || _d === void 0 ? void 0 : _d.motorLegalExpenses) ? "Included" : "Not included")
                    : "Included as standard"),
                this.getDetail(this.getGHCDescription(interaction), this.getGHCIncludeWording(interaction.coverTier, interaction.optionalExtras)),
                React.createElement("div", { className: "no-gutters detail" },
                    React.createElement("div", { className: "detail-value" }, premiumType === services_1.PREMIUM_TYPE_ANNUAL
                        ? '* incl. Insurance Premium Tax'
                        : '* incl. Interest and Insurance Premium Tax')))));
    };
    AnnualQuoteSummaryPanelWidget.prototype.getGHCDescription = function (interaction) {
        if (interaction.coverTier === services_1.ALLIANZ_SILVER) {
            return "Guaranteed hire car if your car is stolen or written off:";
        }
        return "Guaranteed hire car:";
    };
    AnnualQuoteSummaryPanelWidget.prototype.getPriceDetails = function (interaction) {
        var premiumType = interaction.factors.premiumType;
        var premium = this.getPremium(interaction, premiumType);
        return (React.createElement("div", { className: "detail amount-detail d-flex" },
            React.createElement("div", null,
                "Price ",
                React.createElement("span", { className: "price" }, premium),
                " ",
                premiumType === services_1.PREMIUM_TYPE_ANNUAL ?
                    React.createElement("span", { className: "premium-type" }, " / year") :
                    React.createElement("span", { className: "premium-type" }, " / month")),
            premiumType === services_1.PREMIUM_TYPE_MONTHLY &&
                React.createElement("div", { className: "annual-price" },
                    "You pay ",
                    React.createElement("b", null, (0, commonFunctions_1.getAmountToDisplay)(interaction.paymentDetails.instalmentPlan.totalAmount)),
                    " in total")));
    };
    AnnualQuoteSummaryPanelWidget.prototype.getDetail = function (description, value) {
        return (React.createElement("div", { className: "no-gutters detail" },
            React.createElement("div", { className: "justify-content-center row annual font-weight-bold mb-1 detail-key" }, description),
            React.createElement("div", { className: "justify-content-center row annual mb-1 detail-value" }, value)));
    };
    AnnualQuoteSummaryPanelWidget.prototype.renderCarsDetails = function (interaction) {
        var _this = this;
        return this.vehicles.map(function (vehicle, index) { return (React.createElement("div", { key: index, className: "summary-contents" },
            React.createElement("div", { className: "summary-contents-header mb-2" },
                React.createElement("img", { className: "vehicle-icon car-icon", src: "/".concat(services_1.resourcesHelper.THEME, "/img/wolf-car-icon.png"), alt: "Vehicle icon" }),
                React.createElement("div", { className: "subject annual" },
                    React.createElement("div", { className: "subject annual vehicle-model" }, "".concat(vehicle.make, ", ").concat(vehicle.model)),
                    vehicle.registrationNumber ? React.createElement("div", { className: "number-plate-preview" },
                        "(",
                        vehicle.registrationNumber,
                        ")") :
                        React.createElement("div", { className: "link-edit text-center" },
                            React.createElement("div", { className: "col-md-7 d-flex p-0 vrn-text-box" },
                                React.createElement("div", { className: "vrn-text-box__country-code-wrapper" },
                                    React.createElement("span", { className: "vrn-text-box__country-code" }, "GB")),
                                React.createElement("input", { onInput: _this.handleVRNInput, value: _this.state.vrn, type: "text", id: "registrationNumber", maxLength: 7, className: "form-control vrn-input-field ".concat(_this.state.isVRNValid ? "" : "is-invalid"), "aria-label": _this.props.question.label })),
                            " ",
                            !_this.state.isVRNValid &&
                                React.createElement("p", { className: "text-danger" }, "Please enter your car registration number")),
                    React.createElement("div", { className: "subject annual" }, "".concat((0, commonFunctions_1.getVehicleEngineSize)(vehicle), " ").concat((0, commonFunctions_1.getVehicleNumberOfDoors)(vehicle), " ").concat(vehicle.year, ", ").concat(_this.resolveLookupValue("vehicleTransmission", vehicle.transmission), ", ").concat(_this.resolveLookupValue("vehicleFuelType", (0, commonFunctions_1.getInteractionVehicleFuelType)(vehicle.fuelType, vehicle.fuelTypeFull)))),
                    React.createElement("div", { className: "subject annual" }, "Manufactured in ".concat(vehicle.year)),
                    React.createElement("div", { className: "subject annual" }, "Purchased in ".concat((0, commonFunctions_1.convertDate)(vehicle.purchaseDate, "MMM YYYY"))),
                    vehicle.trackerInstalled && React.createElement("div", { className: "subject annual" }, "Tracking device fitted")),
                React.createElement("div", { className: "justify-content-center no-gutters mt-4 detail" },
                    React.createElement("div", { className: "justify-content-center row annual font-weight-bold mb-1 detail-key" }, "Annual mileage:"),
                    React.createElement("div", { className: "justify-content-center row annual mb-4 detail-value" }, "".concat(_this.resolveLookupValue("mileage", vehicle.mileage.toString())))),
                React.createElement("div", { className: "justify-content-center no-gutters mt-4 detail" },
                    React.createElement("div", { className: "justify-content-center row annual font-weight-bold mb-1 detail-key" }, "Postcode where the car is kept:"),
                    React.createElement("div", { className: "justify-content-center row annual mb-4 detail-value" }, "".concat(vehicle.overnightLocationPostcode))),
                React.createElement("div", { className: "justify-content-center no-gutters mt-4 detail" },
                    React.createElement("div", { className: "justify-content-center row annual font-weight-bold mb-1 car-usage detail-key" }, "Car usage:"),
                    React.createElement("div", { className: "justify-content-center row annual mb-4 detail-value" }, "".concat(_this.fetchLookupValue("carUsage", vehicle.classOfUse))))),
            React.createElement("div", { className: "justify-content-center no-gutters mt-4 excess-section" },
                React.createElement("div", { className: "detail" },
                    React.createElement("h2", { className: "text-center mt-3 mb-3 excess-heading padding-bottom-16" }, "Excesses that apply"),
                    React.createElement("div", { className: "detail" },
                        React.createElement("div", { className: "text-center additional-damage detail-key" }, "Accidental damage:"),
                        React.createElement("div", { className: "text-center font-weight-semi-bold price additional-damage-amount detail-value" }, "\u00A3".concat(vehicle.annualVehicleExcess.compulsoryExcess + vehicle.annualVehicleExcess.voluntaryExcess),
                            React.createElement("span", null, " (this includes \u00A3".concat(vehicle.annualVehicleExcess.voluntaryExcess, " voluntary excess)"))),
                        React.createElement("br", null)),
                    React.createElement("div", { className: "detail" },
                        React.createElement("div", { className: "text-center additional-damage detail-key" }, "Fire or theft:"),
                        React.createElement("div", { className: "text-center font-weight-semi-bold price additional-damage-amount detail-value" }, "\u00A3".concat(vehicle.annualVehicleExcess.compulsoryExcess + vehicle.annualVehicleExcess.voluntaryExcess),
                            React.createElement("span", null, " (this includes \u00A3".concat(vehicle.annualVehicleExcess.voluntaryExcess, " voluntary excess)"))),
                        React.createElement("br", null)),
                    React.createElement("div", { className: "mt-4" }, AnnualMotorGlassAndRepairExcessWordingGenerator_1.AnnualMotorGlassAndRepairExcessWordingGenerator.getGlassAndRepairExcessWording(vehicle))),
                vehicle.policyHolderIsLegalOwner && (React.createElement("div", { className: "mb-2 mt-4 text-center legal-owner detail" },
                    React.createElement("div", { className: "justify-content-center row annual font-weight-bold mb-2 mb-1 detail-key" }, "Registered keeper and legal owner:"),
                    React.createElement("div", { className: "justify-content-center row annual detail-value" },
                        interaction.policyHolder.firstName,
                        " ",
                        interaction.policyHolder.lastName))),
                !vehicle.policyHolderIsLegalOwner && (React.createElement("div", { className: "mb-2 mt-4 text-center detail" },
                    React.createElement("div", { className: "justify-content-center row annual font-weight-bold mb-2 mb-1 detail-key" }, "Registered keeper:"),
                    React.createElement("div", { className: "justify-content-center row annual detail-value" }, _this.getRegisteredKeeperOrLegalOwnerWording(vehicle.registeredKeeperId)))),
                !vehicle.policyHolderIsLegalOwner && (React.createElement("div", { className: "mb-2 text-center detail" },
                    React.createElement("div", { className: "justify-content-center row annual font-weight-bold mb-2 mb-1 detail-key" }, "Legal owner:"),
                    React.createElement("div", { className: "justify-content-center row annual detail-value" }, _this.getRegisteredKeeperOrLegalOwnerWording(vehicle.legalOwnerId)))),
                React.createElement("div", { className: "mb-2 text-center" },
                    React.createElement("div", { className: "justify-content-center row annual font-weight-bold mb-2 mb-1 drivers-heading" }, "Driver(s)"),
                    React.createElement("div", { className: "justify-content-center row annual" },
                        React.createElement("div", null, _this.renderVehicleDrivers(interaction, vehicle))))),
            React.createElement("div", { className: "justify-content-center row annual inner-content buttonLink edit-car", id: "editCar", onClick: function () { return _this.navigateToEditCar(index); } },
                React.createElement("button", { type: "button", className: "btn btn-white btn-short mt-1 mb-1" }, "Edit car details")))); });
    };
    AnnualQuoteSummaryPanelWidget.prototype.renderDriversDetails = function (interaction) {
        var _this = this;
        var policyHolder = interaction.policyHolder;
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "summary-contents" },
                React.createElement("div", { className: "summary-contents-header" },
                    React.createElement("img", { className: "vehicle-icon people-icon", src: "/".concat(services_1.resourcesHelper.THEME, "/img/wolf-driver-icon.png"), alt: "Driver icon" }),
                    React.createElement("div", { className: "subject annual driver-name ".concat(this.isDriverNameValid(policyHolder.firstName) && this.isDriverNameValid(policyHolder.lastName) ? "" : "text-danger ") }, "".concat(interaction.policyHolder.firstName, " ").concat(policyHolder.lastName),
                        !(this.isDriverNameValid(policyHolder.firstName) && this.isDriverNameValid(policyHolder.lastName)) &&
                            React.createElement("span", null,
                                React.createElement("div", null, "Your name appears to contain special characters that we don't accept."))),
                    !(this.isDriverNameValid(policyHolder.firstName) && this.isDriverNameValid(policyHolder.lastName)) &&
                        React.createElement("div", { className: "edit-phone-number" },
                            React.createElement("a", { className: "link-edit", id: "policy-holder-name-edit", onClick: function () { return _this.storeDriverAndToggleEditFullNamePopup(interaction.policyHolder, "policyHolder", -1); } }, "Please update your name"))),
                this.renderDriverCommonSections(policyHolder),
                React.createElement("div", { className: "mb-2 text-center detail" },
                    React.createElement("div", { className: "justify-content-center row annual font-weight-bold mb-2 mb-1 detail-key" }, "No claim discount (NCD):"),
                    React.createElement("div", { className: "justify-content-center row annual detail-value" }, policyHolder.ncd.doNotDisclose ? "Protected" : "Not protected")),
                React.createElement("div", { className: "mb-2 text-center detail" },
                    React.createElement("div", { className: "justify-content-center row annual font-weight-bold mb-2 mb-1 detail-key" }, "Years of no claim discount (NCD):"),
                    React.createElement("div", { className: "justify-content-center row annual detail-value" }, policyHolder.ncd.yearCount > 0 ? policyHolder.ncd.yearCount : "None")),
                policyHolder.ncd.earningType &&
                    React.createElement("div", { className: "mb-2 text-center detail" },
                        React.createElement("div", { className: "justify-content-center row annual font-weight-bold mb-2 mb-1 detail-key" }, "NCD earned:"),
                        React.createElement("div", { className: "justify-content-center row annual detail-value" }, "".concat(this.ncdEarnTypeWording(policyHolder.ncd.earningType)))),
                React.createElement("div", { className: "mb-2 text-center detail" },
                    React.createElement("div", { className: "justify-content-center row annual font-weight-bold mb-2 mb-1 detail-key" }, "Address:"),
                    React.createElement("div", { className: "justify-content-center row annual detail-value" }, policyHolder.address.fullAddress)),
                React.createElement("div", { className: "mb-2 text-center detail" },
                    React.createElement("div", { className: "justify-content-center row annual font-weight-bold mb-2 mb-1 detail-key" }, "Email:"),
                    React.createElement("div", { className: "justify-content-center row annual detail-value email-value" }, policyHolder.email)),
                React.createElement(SummaryPhoneNumberInput_1.SummaryPhoneNumberInput, { phoneNumber: policyHolder.phoneNumber, onStateChange: this.props.onStateChange }),
                React.createElement("div", { className: "justify-content-center row annual inner-content buttonLink edit-driver" },
                    React.createElement("button", { type: "button", id: "editPolicyHolder", onClick: function () { return _this.navigateToEditPolicyHolder(); }, className: "btn btn-white btn-short mt-3 mb-1" }, "Edit driver"))),
            interaction.additionalDrivers && interaction.additionalDrivers.length > 0 && this.renderAdditionalDrivers(interaction)));
    };
    AnnualQuoteSummaryPanelWidget.prototype.renderVehicleDrivers = function (interaction, vehicle) {
        var allDrivers = [interaction.policyHolder].concat(interaction.additionalDrivers || []);
        var vehicleDrivers = [];
        if (vehicle.driverIds) {
            vehicleDrivers = vehicle.driverIds.map(function (driverId) { return allDrivers.find(function (driver) { return driverId === driver.personId; }); });
        }
        return vehicleDrivers.map(function (driver, index) {
            return (React.createElement("div", { className: "driver", key: index }, "".concat(driver.firstName, " ").concat(driver.lastName),
                " ",
                driver.personId === vehicle.mainDriverId &&
                    React.createElement("span", null, "(main driver)")));
        });
    };
    AnnualQuoteSummaryPanelWidget.prototype.renderAdditionalDrivers = function (interaction) {
        var _this = this;
        var vehicleAdditionalDrivers = this.getVehiclesAdditionalDrivers(interaction);
        if (vehicleAdditionalDrivers.length > 0) {
            return vehicleAdditionalDrivers.map(function (driver, index) { return (React.createElement("div", { key: index, className: "summary-contents additional-driver-section" },
                React.createElement("div", { className: "summary-contents-header" },
                    React.createElement("img", { className: "driver-icon", src: "/img/wolf-driver-icon.png", alt: "Driver icon" }),
                    React.createElement("div", { className: "subject annual driver-name ".concat(_this.isDriverNameValid(driver.firstName) && _this.isDriverNameValid(driver.lastName) ? "" : "text-danger ") }, "".concat(driver.firstName, " ").concat(driver.lastName),
                        !(_this.isDriverNameValid(driver.firstName) && _this.isDriverNameValid(driver.lastName)) &&
                            React.createElement("span", null,
                                React.createElement("div", null, "Your name appears to contain special characters that we don't accept."))),
                    !(_this.isDriverNameValid(driver.firstName) && _this.isDriverNameValid(driver.lastName)) &&
                        React.createElement("div", { className: "edit-phone-number mb-3" },
                            React.createElement("a", { className: "link-edit", id: "additional-driver-name-edit-".concat(index), onClick: function () { return _this.storeDriverAndToggleEditFullNamePopup(driver, "additionalDriver", index); } }, "Please update your name"))),
                _this.renderDriverCommonSections(driver),
                React.createElement("div", { className: "additional-driver-buttons" },
                    React.createElement("div", { className: "justify-content-center row annual inner-content buttonLink edit-driver", id: "ditAdditionalDriver".concat(index), onClick: function () { return _this.navigateToEditAdditionalDriver(index); } },
                        React.createElement("button", { type: "button", className: "btn btn-white btn-short" }, "Edit driver")),
                    React.createElement("div", { className: "justify-content-center row annual inner-content buttonLink delete-driver", id: "ditAdditionalDriver".concat(index), onClick: function () { return _this.removeAdditionalDriver(driver.personId, 0); } },
                        React.createElement("button", { type: "button", className: "btn btn-white btn-short" }, "Delete driver"))))); });
        }
        else {
            return React.createElement(React.Fragment, null);
        }
    };
    AnnualQuoteSummaryPanelWidget.prototype.renderDriverCommonSections = function (driver) {
        return React.createElement(React.Fragment, null,
            React.createElement("div", { className: "mb-2 text-center detail" },
                React.createElement("div", { className: "justify-content-center row annual font-weight-bold mb-2 mb-1 detail-key" }, "Date of birth:"),
                React.createElement("div", { className: "justify-content-center row annual detail-value" }, (0, commonFunctions_1.convertDate)(driver.dateOfBirth, "DD MMMM YYYY"))),
            this.renderDrivingLicenceNumber(driver),
            React.createElement("div", { className: "mb-2 text-center detail" },
                React.createElement("div", { className: "justify-content-center row annual font-weight-bold mb-2 mb-1 detail-key" }, "Claims in the last 5 years:"),
                React.createElement("div", { className: "justify-content-center row annual detail-value" }, this.renderClaims(driver))),
            React.createElement("div", { className: "mb-2 text-center detail" },
                React.createElement("div", { className: "justify-content-center row annual font-weight-bold mb-2 mb-1 detail-key" }, "Criminal convictions:"),
                React.createElement("div", { className: "justify-content-center row annual detail-value" }, "None")),
            this.renderMotoringConvictions(driver));
    };
    AnnualQuoteSummaryPanelWidget.prototype.renderVrnPopup = function (interaction) {
        var vehicleIndex = this.state.vrnEditVehicleIndex;
        var make = interaction.vehicles[vehicleIndex].make;
        var model = interaction.vehicles[vehicleIndex].model;
        var closeBtn = React.createElement("button", { className: "btn-close", onClick: this.toggle });
        var title = "Please provide " + make + ", " + model + " registration number";
        var validationMessage = null;
        if (!this.state.vrnValidated) {
            validationMessage = "That registration number doesn’t look right... Please check and try again";
        }
        else if (!this.state.vrnAllowed) {
            validationMessage = "Sorry we are unable to insure this vehicle";
        }
        return (React.createElement("div", null,
            React.createElement(reactstrap_1.Modal, { className: "my-2 info-modal", isOpen: this.state.vrnEditPopupOpened, toggle: this.toggle },
                React.createElement(reactstrap_1.ModalHeader, { toggle: this.toggle, close: closeBtn },
                    React.createElement("div", { className: "d-flex" },
                        React.createElement("img", { className: "d-block warning-icon", src: "/".concat(services_1.resourcesHelper.THEME, "/img/alert-grey-blue.svg"), alt: "Attention icon" }),
                        React.createElement("div", { className: "text-blue-2 font-weight-medium fs-20" }, title))),
                React.createElement(reactstrap_1.ModalBody, { className: "pt-0 overflow-auto" },
                    React.createElement("p", null,
                        "You need to provide us below the registration number of ",
                        make,
                        ", ",
                        model),
                    React.createElement("div", { className: "custom-margin-mobile-cut-sides" },
                        React.createElement("p", null,
                            React.createElement("b", null,
                                make,
                                ", ",
                                model,
                                " registration number")),
                        React.createElement("div", { className: "col-md-7 d-flex p-0 vrn-text-box" },
                            React.createElement("div", { className: "vrn-text-box__country-code-wrapper" },
                                React.createElement("span", { className: "vrn-text-box__country-code" }, "GB")),
                            React.createElement("input", { onChange: this.handleRegistrationNumberChange, onBlur: this.executeNativeEvent, onFocus: this.executeNativeEvent, onClick: this.executeNativeEvent, value: this.state.editableVehicleVrn, type: "text", id: "registrationNumber", className: "form-control vrn-input-field", "aria-label": this.props.question.label })),
                        validationMessage && (React.createElement("span", { className: "text-danger" }, validationMessage)))),
                React.createElement(reactstrap_1.ModalFooter, { className: "d-block custom-margin-mobile-cut-sides" },
                    React.createElement("button", { type: "button", className: "btn btn-primary  ".concat(this.state.vrnValidated && this.state.vrnAllowed ? "" : "btn-disabled ", " btn-next-arrow-separate"), onClick: this.saveRegistrationNumberChanges }, "Save"),
                    React.createElement("button", { type: "button", className: "btn btn-back", onClick: this.toggle }, "Cancel")))));
    };
    AnnualQuoteSummaryPanelWidget.prototype.renderFullNameEditPopup = function () {
        var _this = this;
        var closeBtn = React.createElement("button", { className: "btn-close", onClick: function () { return _this.toggleEditFullNamePopup(); } });
        var title = "Update your name";
        return (React.createElement(React.Fragment, null,
            React.createElement(reactstrap_1.Modal, { className: "edit-name-modal my-2 info-modal", isOpen: this.state.editFullNamePopupOpened, toggle: function () { return _this.toggleEditFullNamePopup(); } },
                React.createElement(reactstrap_1.ModalHeader, { toggle: function () { return _this.toggleEditFullNamePopup(); }, close: closeBtn },
                    React.createElement("div", { className: "d-flex" },
                        React.createElement("img", { className: "d-block warning-icon", src: "/".concat(services_1.resourcesHelper.THEME, "/img/alert-grey-blue.svg"), alt: "Attention icon" }),
                        React.createElement("div", { className: "text-blue-2 font-weight-medium fs-20" }, title))),
                React.createElement(reactstrap_1.ModalBody, { className: "pt-0 overflow-auto" },
                    React.createElement("div", { className: "mb-3" },
                        React.createElement("p", { className: "m-0" }, "Your name appears to contain special characters that we don't accept. Please update your name below"),
                        this.isDriverNameAppropriateForLicenceNumber(this.state.editFullNameDriver) &&
                            React.createElement("p", { className: "mt-3 text-danger" }, "Your driving licence number doesn\u2019t look right! We validate driving licence number against your name, surname and date of birth, make sure these are entered correctly")),
                    React.createElement("div", { className: "custom-margin-mobile-cut-sides mr-4 ml-4" },
                        React.createElement("p", null,
                            React.createElement("span", { className: "font-weight-bold" }, "First name")),
                        React.createElement("div", { className: "col-md-7 d-flex p-0" },
                            React.createElement("input", { onChange: this.handleNameChange, onBlur: this.executeNativeEvent, onFocus: this.executeNativeEvent, onClick: this.executeNativeEvent, value: this.state.editFullNameDriver.firstName, type: "text", id: "firstNameChange", className: "form-control", "aria-label": this.props.question.label }))),
                    React.createElement("div", { className: "custom-margin-mobile-cut-sides mr-4 ml-4" },
                        React.createElement("p", null,
                            React.createElement("span", { className: "font-weight-bold" }, "Last name")),
                        React.createElement("div", { className: "col-md-7 d-flex p-0" },
                            React.createElement("input", { onChange: this.handleNameChange, onBlur: this.executeNativeEvent, onFocus: this.executeNativeEvent, onClick: this.executeNativeEvent, value: this.state.editFullNameDriver.lastName, type: "text", id: "lastNameChange", className: "form-control", "aria-label": this.props.question.label })))),
                React.createElement(reactstrap_1.ModalFooter, { className: "d-block custom-margin-mobile-cut-sides" },
                    React.createElement("button", { type: "button", className: "btn btn-primary ".concat(this.isDriverNameValid(this.state.editFullNameDriver.firstName)
                            && this.isDriverNameValid(this.state.editFullNameDriver.lastName)
                            && this.isDriverNameAppropriateForLicenceNumber(this.state.editFullNameDriver) ? "" : "btn-disabled ", " btn-next-arrow-separate width-md-250"), onClick: function (e) { return _this.saveFullNameChanges(e, _this.state.editFullNameDriverType, _this.state.editFullNameDriverIndex); }, id: "nameChangeSaveButton" }, "Save & continue"),
                    React.createElement("button", { type: "button", className: "btn btn-back width-md-250", onClick: function () { return _this.toggleEditFullNamePopup(); } }, "Cancel")))));
    };
    AnnualQuoteSummaryPanelWidget.prototype.renderDrivingLicenceNumber = function (driver) {
        var _a;
        if (driver.drivingLicenceHandy && ((_a = driver.dlnLookupData) === null || _a === void 0 ? void 0 : _a.dlnLookupCallSucess)) {
            return (React.createElement("div", { className: "mb-2 text-center detail" },
                React.createElement("div", { className: "justify-content-center row annual font-weight-bold mb-2 mb-1 detail-key" }, "Driving licence number:"),
                React.createElement("div", { className: "justify-content-center row annual" }, driver.licence.number)));
        }
        else {
            return (React.createElement("div", { className: "mb-2 text-center detail" },
                React.createElement("div", { className: "justify-content-center row annual font-weight-bold mb-2 mb-1 detail-key" }, "Driving licence type:"),
                React.createElement("div", { className: "justify-content-center row annual detail-value" }, this.fetchLookupValue("drivingLicenceTypes", driver.licence.type.toString()))));
        }
    };
    AnnualQuoteSummaryPanelWidget.prototype.renderClaims = function (driver) {
        var _this = this;
        var _a;
        if (driver.hasClaims && driver.numberOfClaims > 0 && ((_a = driver.claims) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            return driver.claims.map(function (claim, index) { return (React.createElement("div", { key: index, className: "justify-content-center row annual detail-value" }, "".concat(_this.resolveLookupValue("claimType", claim.claimType), ", ").concat((0, commonFunctions_1.convertDate)(claim.date, "MMM YYYY")))); });
        }
        else {
            return React.createElement("div", { className: "justify-content-center row annual detail-value" }, "None");
        }
    };
    AnnualQuoteSummaryPanelWidget.prototype.renderMotoringConvictions = function (driver) {
        var _a;
        if ((_a = driver === null || driver === void 0 ? void 0 : driver.dlnLookupData) === null || _a === void 0 ? void 0 : _a.dlnLookupCallSucess) {
            return (React.createElement("div", { className: "mb-2 text-center detail" },
                React.createElement("div", { className: "justify-content-center row annual font-weight-bold mb-2 mb-1 detail-key" }, "Motoring convictions:"),
                React.createElement("div", { className: "justify-content-center row annual detail-value" }, "As per your DVLA records")));
        }
        else {
            return (React.createElement("div", { className: "mb-2 text-center detail" },
                React.createElement("div", { className: "justify-content-center row annual font-weight-bold mb-2 mb-1 detail-key" }, "Motoring convictions:"),
                this.renderConvictionDetails(driver)));
        }
    };
    AnnualQuoteSummaryPanelWidget.prototype.renderConvictionDetails = function (driver) {
        var _a;
        if (driver.hasConvictions && ((_a = driver.convictions) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            return driver.convictions.map(function (conviction, index) { return (React.createElement("div", { key: index, className: "justify-content-center row annual detail-value" }, "".concat(conviction.convictionCode, ", ").concat((0, commonFunctions_1.convertDate)(conviction.convictionDate, "MMM YYYY")))); });
        }
        else {
            return React.createElement("div", { className: "justify-content-center row annual detail-value" }, "None");
        }
    };
    AnnualQuoteSummaryPanelWidget.prototype.navigateToEditCar = function (vehicleIndex) {
        if (vehicleIndex === 0) {
            this.props.engine.navigate("carDetails", false);
        }
        else {
            this.props.engine.navigate("additionalVehicle".concat(vehicleIndex, "DetailsPage"), false);
        }
    };
    AnnualQuoteSummaryPanelWidget.prototype.openEditRegNumberPopup = function (vehicleIndex) {
        this.setState({
            vrnEditVehicleIndex: vehicleIndex,
            vrnEditPopupOpened: true
        });
    };
    AnnualQuoteSummaryPanelWidget.prototype.navigateToEditPolicyHolder = function () {
        this.props.engine.navigate("drivingLicenceScan", false);
    };
    AnnualQuoteSummaryPanelWidget.prototype.navigateToEditAdditionalDriver = function (driverIndex) {
        this.props.engine.navigate("editAdditionalDriver".concat(driverIndex + 1, "DrivingLicenceScanPage"), false);
    };
    AnnualQuoteSummaryPanelWidget.prototype.fetchLookupValues = function (lookupName) {
        var _this = this;
        this.lookupService.fetchLookupValues(lookupName, "en-UK").subscribe(function (lookupValues) {
            _this.state.lookup[lookupName] = lookupValues;
            _this.setState({ lookup: _this.state.lookup });
        }, function () {
            throw new Error("Error: failed to fetch lookup values for '".concat(lookupName, "' lookup"));
        });
    };
    AnnualQuoteSummaryPanelWidget.prototype.resolveLookupValue = function (lookupName, lookupId) {
        if (!lookupId || !this.state.lookup || !this.state.lookup[lookupName]) {
            return "";
        }
        var listItem = this.state.lookup[lookupName].find(function (listItem) { return "".concat(listItem.id) === "".concat(lookupId); });
        if (!listItem) {
            throw new Error("Error: no item with id '".concat(lookupId, "' found in lookup '").concat(lookupName, "'"));
        }
        return listItem.value;
    };
    AnnualQuoteSummaryPanelWidget.prototype.toggle = function () {
        this.setState(function (state) { return ({
            vrnEditPopupOpened: !state.vrnEditPopupOpened
        }); });
    };
    AnnualQuoteSummaryPanelWidget.prototype.toggleEditFullNamePopup = function () {
        this.setState(function (state) { return ({
            editFullNamePopupOpened: !state.editFullNamePopupOpened,
            editFullNameDriver: null,
            editFullNameDriverType: "",
            editFullNameDriverIndex: -1
        }); });
    };
    AnnualQuoteSummaryPanelWidget.prototype.storeDriverAndToggleEditFullNamePopup = function (driver, driverType, driverIndex) {
        this.setState(function (state) { return ({
            editFullNamePopupOpened: !state.editFullNamePopupOpened,
            editFullNameDriver: driver,
            editFullNameDriverType: driverType,
            editFullNameDriverIndex: driverIndex
        }); });
    };
    AnnualQuoteSummaryPanelWidget.prototype.allDriverNamesAreValid = function () {
        var _this = this;
        var interaction = this.props.engine.getInteraction();
        var policyHolder = interaction.policyHolder;
        var additionalDrivers = interaction.additionalDrivers;
        var hasInvalidPolicyHolderName = !(this.isDriverNameValid(policyHolder.firstName) && this.isDriverNameValid(policyHolder.lastName)
            && this.isDriverNameAppropriateForLicenceNumber(policyHolder));
        var hasInvalidAdditionalDriverNames = !additionalDrivers || additionalDrivers.length === 0 ?
            false : !additionalDrivers.every(function (element) {
            return _this.isDriverNameValid(element.firstName) && _this.isDriverNameValid(element.lastName) && _this.isDriverNameAppropriateForLicenceNumber(element);
        });
        return !hasInvalidPolicyHolderName && !hasInvalidAdditionalDriverNames;
    };
    AnnualQuoteSummaryPanelWidget.prototype.isDriverNameAppropriateForLicenceNumber = function (driver) {
        var regex = /\s/;
        // If customer does not have a licence number provided (which can happen in case of aggregators), we assume it's correct.
        if (driver.licence.number == null) {
            return true;
        }
        var trimmedLicence = driver.licence.number.replace(regex, '');
        return drivingLicenceHelper_1.default.validateFirstNameSection(driver.firstName, trimmedLicence.substring(11, 13).toUpperCase()) &&
            drivingLicenceHelper_1.default.validateLastNameSection(driver.lastName, trimmedLicence.substring(0, 5).toUpperCase());
    };
    AnnualQuoteSummaryPanelWidget.prototype.isDriverNameValid = function (name) {
        var expression = /^[a-z ,.'-]+$/i;
        return expression.test(name);
    };
    AnnualQuoteSummaryPanelWidget.prototype.breakdownCoverWording = function (optionalExtras) {
        if (optionalExtras.breakdownCover === false) {
            return "Not included";
        }
        switch (optionalExtras.breakdownCoverLevel) {
            case services_1.BreakdownCoverLevelEnum.LOCAL:
                return "Included (Local)";
            case services_1.BreakdownCoverLevelEnum.UK:
                return "Included (National)";
            case services_1.BreakdownCoverLevelEnum.EU:
                return "Included (European)";
            default:
                throw new Error("Unknown Breakdown Cover level: ".concat(optionalExtras.breakdownCoverLevel));
        }
    };
    AnnualQuoteSummaryPanelWidget.prototype.fetchLookupValue = function (fieldId, id) {
        var value = "";
        this.lookupService.fetchLookupValues(fieldId, "en-UK").subscribe(function (lookupValues) {
            var _a, _b;
            value = (_b = (_a = lookupValues === null || lookupValues === void 0 ? void 0 : lookupValues.find(function (entry) { return entry.id === id; })) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : "";
        });
        return value;
    };
    AnnualQuoteSummaryPanelWidget.prototype.getRegisteredKeeperOrLegalOwnerWording = function (id) {
        var interaction = this.props.engine.getInteraction();
        var variants = new Map([
            [1, "Brother / Sister"],
            [2, "Child"],
            [3, "Common Law / Partner"],
            [4, "Company"],
            [5, "Lease Company"],
            [6, "Parent"],
            [7, "Other Relative"],
            [8, "Spouse / Civil Partner"],
            [9, "Other / Friend"]
        ]);
        if (Number(id) === 0) {
            return "".concat(interaction.policyHolder.firstName, " ").concat(interaction.policyHolder.lastName);
        }
        return variants.get(Number(id));
    };
    AnnualQuoteSummaryPanelWidget.prototype.ncdEarnTypeWording = function (id) {
        var interaction = this.props.engine.getInteraction();
        var vehicle = interaction.vehicles[0];
        var variants = new Map([
            [1, "With ".concat(vehicle.make, ", ").concat(vehicle.model, " ").concat(vehicle.registrationNumber ? vehicle.registrationNumber : "", " or a previous car")],
            [2, "With a company car"],
            [3, "Named driver on another policy"],
            [4, "In another country"]
        ]);
        return variants.get(Number(id));
    };
    AnnualQuoteSummaryPanelWidget.prototype.removeAdditionalDriver = function (driverPersonId, vehicleIndex) {
        var vehicle = this.props.interaction.vehicles[vehicleIndex];
        var driverIdIndex = vehicle.driverIds.findIndex(function (id) { return id.localeCompare(String(driverPersonId)) === 0; });
        if (driverIdIndex > -1) {
            vehicle.driverIds.splice(driverIdIndex, 1);
        }
        var additionalDrivers = this.props.interaction.additionalDrivers;
        var driverIndex = additionalDrivers.findIndex(function (driver) { return driver.personId.localeCompare(driverPersonId) === 0; });
        if (driverIndex > -1) {
            additionalDrivers.splice(driverIndex, 1);
        }
        // if main driver is deleted and new main driver is not set, Polaris will fail to process such interaction
        if (vehicle.mainDriverId === driverPersonId) {
            vehicle.mainDriverId = this.props.interaction.policyHolder.personId;
        }
        vehicle.numberOfDrivers -= 1;
        this.props.onStateChange("additionalDrivers", additionalDrivers);
        this.props.onStateChange("vehicles[".concat(vehicleIndex, "]"), vehicle);
        this.executeEvent("change");
    };
    AnnualQuoteSummaryPanelWidget.prototype.handleVRNInput = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var vrn, isValid;
            return __generator(this, function (_a) {
                vrn = event.target.value.trim().toUpperCase();
                isValid = this.validateVRN(vrn);
                this.setState({ isVRNValid: isValid });
                this.setState({ vrn: vrn });
                if (isValid) {
                    this.props.onStateChange("vehicles[0].registrationNumber", vrn);
                }
                else {
                    this.props.onStateChange("vehicles[0].registrationNumber", null);
                }
                return [2 /*return*/];
            });
        });
    };
    AnnualQuoteSummaryPanelWidget.prototype.validateVRN = function (vrn) {
        return services_1.VEHICLE_REG_NUMBER_REGEX.test(vrn);
    };
    AnnualQuoteSummaryPanelWidget.prototype.getPremium = function (interaction, premiumType) {
        return premiumType === services_1.PREMIUM_TYPE_ANNUAL ? "".concat((0, commonFunctions_1.getAmountToDisplay)(interaction.factors.annualPremium))
            : "".concat((0, commonFunctions_1.getAmountToDisplay)(interaction.factors.monthlyPremium));
    };
    AnnualQuoteSummaryPanelWidget.prototype.getGHCIncludeWording = function (coverTier, optionalExtras) {
        switch (coverTier) {
            case services_1.ALLIANZ_SILVER: return optionalExtras.courtesyCarTotalLoss ? "Included" : "Not included";
            case services_1.ALLIANZ_ESSENTIALS: return optionalExtras.courtesyCar ? "Included" : "Not included";
            default: return "Included as standard";
        }
    };
    __decorate([
        (0, core_1.lazyInject)(plugin_journey_1.Types.LookupService),
        __metadata("design:type", Object)
    ], AnnualQuoteSummaryPanelWidget.prototype, "lookupService", void 0);
    return AnnualQuoteSummaryPanelWidget;
}(plugin_journey_1.WidgetBase));
//# sourceMappingURL=AnnualQuoteSummaryPanelWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/annual/motor/AnnualQuoteSummaryPanelWidget.js
// module id = 3177
// module chunks = 0